
import { createDeckWidgetQueue } from './script_request_queue';

var deckWidgetQueue = createDeckWidgetQueue();

function fetchScript(url, params) {
  deckWidgetQueue.enqueue(url, params);
}

function initializeTypePreference() {
  var preference = getCurrentTypePreference()
  showDeckContainerTab(preference);
}

var showDeckContainerTab = function(preference) {
  document.querySelectorAll('.type-switcher-tabs, .deck-action-menu, .deck-price-menu').forEach(function(container) {
    var selected = findPreferredTabTrigger(container, preference);
    if (selected) {
      bootstrap.Tab.getOrCreateInstance(selected).show();
    }
  });
}

function findPreferredTabTrigger(container, preference) {
  if (!container || !preference) return null;
  // Use indexOf rather than .match() — .match() compiles `preference` as a
  // regex, and the URL fragment can contain regex metacharacters (e.g. a
  // trailing backslash from a Facebook fbclid like #paper\) that would crash
  // here with "Invalid regular expression: /tab-paper\/".
  var needle = "tab-" + preference;
  var matches = Array.from(container.querySelectorAll('a[data-bs-toggle="tab"]')).filter(function(el) {
    var href = el.getAttribute("href");
    return href && href.indexOf(needle) !== -1;
  });
  return matches.find(function(el) { return !el.classList.contains('dropdown-item'); }) || matches[0] || null;
}

function deckDisplayParams(container) {
  if (!container) return {};
  return {
    deck_group: container.dataset.deckGroup || 'type',
    deck_sort: container.dataset.deckSort || 'mana_value',
    deck_sort_direction: container.dataset.deckSortDirection || 'auto',
  };
}

function initializeDeckComponents(tabId, deckId, deckString, viewModeOverride, allowEmptyDeck, deckFormat, companion) {
  var deckStringIfNoDeckId = (deckId == null || deckId =="") ? deckString : "";
  var hasDeckSource = (deckId != null && deckId !== "") || (deckStringIfNoDeckId != null && deckStringIfNoDeckId !== "") || allowEmptyDeck === true;
  var container = document.getElementById(tabId);

  function requestBaseParams(tab, hash) {
    return Object.assign({
      type: tab.dataset.type,
      id: deckId,
      deck: deckStringIfNoDeckId,
      deck_format: deckFormat,
      companion: companion,
      selector: hash,
      view_mode_override: viewModeOverride,
    }, deckDisplayParams(container));
  }

  function loadPane(tab, hash) {
    if (!hasDeckSource) return;
    if (!tab) return;
    if (tab.dataset.myPrice && !tab.dataset.loaded) {
      fetchScript('/deck/my_price_js', requestBaseParams(tab, hash));
    } else if (tab.dataset.deckComponent && !tab.dataset.loaded) {
      fetchScript('/deck/component', requestBaseParams(tab, hash));
    } else if (tab.dataset.deckStats && !tab.dataset.loaded) {
      fetchScript('/deck/stats', Object.assign({
        id: deckId,
        type: tab.dataset.type,
        deck: deckStringIfNoDeckId,
        deck_format: deckFormat,
        companion: companion,
        selector: hash,
        view_mode_override: viewModeOverride,
      }, deckDisplayParams(container)));
    }
  }

  function loadTab(tabEl) {
    if (!container || !container.contains(tabEl)) return;
    if (!tabEl.matches('[data-bs-toggle="tab"]')) return;
    var hash = tabEl.getAttribute('href') || tabEl.dataset.bsTarget;
    // Use getElementById so numeric IDs (e.g. "413-tab-paper") work — those
    // start with a digit and are invalid as CSS selectors for querySelector.
    var tabId2 = hash && hash.charAt(0) === '#' ? hash.slice(1) : hash;
    var tab = tabId2 ? document.getElementById(tabId2) : null;
    loadPane(tab, hash);
  }

  function activeDeckPane() {
    if (!container) return null;
    return container.querySelector('.tab-pane.active[data-deck-component="true"], .tab-pane.active[data-my-price="true"]');
  }

  function reloadActiveDeckPane() {
    var tab = activeDeckPane();
    if (!tab) return;
    tab.innerHTML = "<p class='text-center text-muted'>Loading ...</p>";
    loadPane(tab, '#' + tab.id);
  }

  function resetDeckPanes() {
    if (!container) return;
    container.querySelectorAll('.tab-pane[data-deck-component="true"], .tab-pane[data-my-price="true"]').forEach(function(tab) {
      delete tab.dataset.loaded;
    });
  }

  document.addEventListener('shown.bs.tab', function(e) {
    loadTab(e.target);
  });

  var initialPreference = getCurrentTypePreference();
  var initialTab = findPreferredTabTrigger(container, initialPreference);
  if (!initialTab) {
    initialTab = document.querySelector('#' + CSS.escape(tabId) + ' a.nav-link.active[data-bs-toggle="tab"]');
  }
  if (initialTab) {
    loadTab(initialTab);
  } else {
    var initialPane = activeDeckPane();
    if (initialPane) loadPane(initialPane, '#' + initialPane.id);
  }

  if (container) {
    container.addEventListener('change', function(e) {
      var control = e.target && e.target.closest('.deck-display-control-select');
      if (!control) return;

      var groupControl = container.querySelector('.deck-display-group');
      var sortControl = container.querySelector('.deck-display-sort');
      var directionControl = container.querySelector('.deck-display-direction');
      if (groupControl) container.dataset.deckGroup = groupControl.value;
      if (sortControl) container.dataset.deckSort = sortControl.value;
      if (directionControl) container.dataset.deckSortDirection = directionControl.value;
      resetDeckPanes();
      reloadActiveDeckPane();
    });

    container.addEventListener('click', function(e) {
      var toggle = e.target && e.target.closest('.deck-view-options-toggle');
      if (!toggle) return;
      var shell = container.querySelector('.deck-display-controls-shell');
      if (!shell) return;
      var open = !shell.classList.contains('is-open');
      shell.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
}


var getCurrentTypePreference = function() {
  var url = document.location.toString();
  if (url.match('#')) {
    return url.split('#')[1];
  } else {
    var preference = Cookies.get('type-preference');
    if (preference == "online") {
    } else if (preference == "arena") {
    } else {
      preference = "paper";
    }
    return preference;
  }
}
window.getCurrentTypePreference = getCurrentTypePreference

function splitDecklistsIntoTwoColumns() {
  // only do for firefox and desktop
  if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 && window.matchMedia("screen and (min-width: 900px)").matches) {
    document.querySelectorAll(".deck-table-container").forEach(function(container) {
      var tables = container.querySelectorAll(".deck-view-deck-table");
      if (tables.length !== 1) return;
      var table = tables[0];
      var secondTable = table.cloneNode(false);
      var rows = table.querySelectorAll("tr");
      var rowCount = Math.round(rows.length * 0.5);
      var tbody = document.createElement('tbody');
      secondTable.appendChild(tbody);
      Array.from(rows).slice(rowCount).forEach(function(row) {
        tbody.appendChild(row);
      });
      table.parentNode.appendChild(secondTable);
    });
  }
}

window.MTGGoldfish = MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() {
  splitDecklistsIntoTwoColumns();

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.matches('.decklist-more')) return;
    e.target.style.display = 'none';
    var more = e.target.closest(".decklist-more-container");
    if (more) {
      var purchase = more.querySelector(".decklist-purchase-more");
      if (purchase) purchase.style.display = '';
    }
  });

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.matches('.deck-tools-btn-download-submit')) return;
    e.preventDefault();
    var form = e.target.closest('form');
    if (!form) return;
    var outputField = form.querySelector(".field-output");
    var typeField = form.querySelector(".field-type");
    if (outputField) outputField.value = e.target.dataset.output;
    if (typeField) typeField.value = e.target.dataset.type;
    form.submit();
  });

  document.querySelectorAll(".copy-paste-box").forEach(function(el) {
    el.style.height = el.scrollHeight + "px";
    el.addEventListener('click', function() { el.select(); });
  });

  document.querySelectorAll(".auto-select-text").forEach(function(el) {
    el.addEventListener('click', function() { el.select(); });
  });

  document.querySelectorAll(".my-decks-btn-add").forEach(function(el) {
    el.addEventListener('click', function(e) {
      var target = el.dataset.target;
      var textarea = document.getElementById(target);
      var card = document.querySelector('.add-card-' + target);
      var qty = document.querySelector('.add-qty-' + target);
      if (textarea && card && qty) {
        textarea.value = textarea.value + "\n" + qty.value + " " + card.value;
      }
    });
  });

  function showDecksTab(panelName) {
    var filterPanel = document.getElementById("search-filter-panel");
    if (filterPanel) filterPanel.value = panelName;

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const params = new URLSearchParams({ panel: panelName });
    const url = `/decks?${params.toString()}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': csrfToken
      },
      credentials: 'same-origin'
    })
    .then(response => {
      if (!response.ok) throw new Error("Turbo Stream request failed");
      return response.text();
    })
    .then(html => {
      Turbo.renderStreamMessage(html);
    })
    .catch(error => {
      console.error(error);
    });
  }

  document.addEventListener('shown.bs.tab', function(e) {
    var tabEl = e.target;
    var container = document.getElementById('mydecks-tabs');
    if (!container || !container.contains(tabEl)) return;
    if (!tabEl.matches('[data-bs-toggle="tab"]')) return;
    var hash = tabEl.getAttribute('href') || tabEl.dataset.bsTarget;
    if (hash !== "#tab-search") {
      showDecksTab(hash);
    }
    var relatedHash = e.relatedTarget && (e.relatedTarget.getAttribute('href') || e.relatedTarget.dataset.bsTarget);
    if (relatedHash) {
      var relatedPaneId = relatedHash.charAt(0) === '#' ? relatedHash.slice(1) : relatedHash;
      var relatedTab = document.getElementById(relatedPaneId);
      if (relatedTab) {
        if (hash === "#tab-search") {
          relatedTab.innerHTML = "<p class='empty'>Search Results have expired. Please search again.</p>";
        } else {
          relatedTab.innerHTML = "<p class='empty'>Loading ...</p>";
        }
      }
    }
  });

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest('.hidden-form-submit')) return;
    var submitEl = e.target.closest('.hidden-form-submit');
    var hiddenForm = submitEl.querySelector(".hidden-form");
    if (!hiddenForm) return;
    var f = document.createElement('form');
    f.target = '_blank';
    f.method = 'POST';
    f.style.display = 'none';
    f.action = hiddenForm.dataset.url;
    hiddenForm.querySelectorAll(".hidden-form-input").forEach(function(inp) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = inp.dataset.name;
      input.value = inp.dataset.value;
      f.appendChild(input);
    });
    document.body.appendChild(f);
    f.submit();
    document.body.removeChild(f);
  });

});

window.initializeDeckComponents = initializeDeckComponents;
window.splitDecklistsIntoTwoColumns = splitDecklistsIntoTwoColumns;
window.initializeTypePreference = initializeTypePreference;
